import { render, staticRenderFns } from "./VocabularyMemo.vue?vue&type=template&id=7c7e1af7&lang=pug&"
import script from "./VocabularyMemo.vue?vue&type=script&lang=js&"
export * from "./VocabularyMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports